/** Stable identifier used for the root route in a route tree. */
export const rootRouteId = '__root__'
export type RootRouteId = typeof rootRouteId
